import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { Box, Flex, Link, Text } from '@opendoor/bricks/core';
import { fontSizesNamed } from '@opendoor/bricks/theme/eero';

import { EntryComponent } from '../../cms/entries/entries';
import renderImage from '../../cms/renderer/assets';
import { IComponentIconText } from '../../declarations/contentful';

const pictureIconSize = fontSizesNamed.s5 as number;

const renderIconText = (entry: IComponentIconText) => {
  const fields = entry.fields;
  return (
    <Flex>
      {fields.textIcon ? (
        <Text lineHeight="s5" size="s5" mt="auto" mb="auto">
          {fields.textIcon}
        </Text>
      ) : (
        fields.pictureIcon && (
          <Box height={pictureIconSize} width={pictureIconSize}>
            {renderImage({
              src: fields.pictureIcon.fields?.file?.url,
              width: pictureIconSize,
              height: pictureIconSize,
            })}
          </Box>
        )
      )}
      {fields.labelText &&
        documentToReactComponents(fields.labelText, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => {
              return (
                <Text lineHeight="s5" fontSize="s2" ml="2" mt="auto" mb="auto">
                  {children}
                </Text>
              );
            },
            [INLINES.HYPERLINK]: (node, children) => {
              return (
                <Link
                  href={node.data.uri}
                  lineHeight="s5"
                  fontSize="s2"
                  target="_blank"
                  analyticsName="cosmos-articles-icon-text"
                  aria-label=""
                >
                  {children}
                </Link>
              );
            },
          },
        })}
    </Flex>
  );
};

const IconText: EntryComponent<IComponentIconText> = {
  render: renderIconText,
};

export default IconText;
